import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableRow,
} from '@safedns/skydns-ui-react-lib';

import DomainControllerTableRow from './DomainControllerTableRow';
import DeleteDomainController from './DeleteDomainController';

import {
  useGetUserQuery,
  useGetDomainControllersQuery,
} from '../../services/ADapi';

import { actionTableCellStyle } from '../../styles/tableStyles';

const DomainControllerTable = () => {
  const {
    data: { user_id },
  } = useGetUserQuery();
  const { data: controllers, isLoading } =
    useGetDomainControllersQuery(user_id);

  if (isLoading) return <h2>Loading...</h2>;

  return (
    <TableContainer>
      <Table sx={{ minWidth: '650px' }}>
        <TableHead>
          <TableRow>
            <TableHeadCell sx={{ width: 200, textAlign: 'left' }}>
              Домен контроллер
            </TableHeadCell>
            <TableHeadCell sx={{ width: 450, textAlign: 'left' }}>
              IP адрес
            </TableHeadCell>
            <TableHeadCell sx={{ textAlign: 'left' }}>Тип</TableHeadCell>
            <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
            <TableHeadCell sx={actionTableCellStyle}></TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {controllers.map(({ id, name, ips, is_pdc }) => (
            <DomainControllerTableRow
              key={`${id}-controller`}
              id={id}
              name={name}
              numberOfIPs={ips.length}
              isPDC={is_pdc}
            />
          ))}
        </TableBody>
      </Table>
      <DeleteDomainController />
    </TableContainer>
  );
};

export default DomainControllerTable;
